import { render, staticRenderFns } from "./PointsComponent.vue?vue&type=template&id=56b17d8b&scoped=true"
import script from "./PointsComponent.vue?vue&type=script&lang=ts"
export * from "./PointsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b17d8b",
  null
  
)

export default component.exports